export const LOCAL_DEV_STRING = '.xps-user-portal.pages.dev'

export const isDev = import.meta.env.DEV || window.location.hostname.includes(LOCAL_DEV_STRING)

export const checkIsStaging = (): boolean => {
  return window?.location?.href.includes('staging') || isDev
}

export const isStaging = checkIsStaging()
